<template>
	<div>
		<el-timeline>
			<template v-for="(item,index) in newsList" :key="index">
				<!-- <el-timeline-item center :timestamp="parseTime(item.timeConf,'{y}/{m}/{d}')" placement="top"> -->
					<el-card @click="toDetail(item)">
						<div class="imgBox">
							<img :src="item.resourceLink">
						</div>
						<div class="conBox">
							<h4>
								{{ item.title }}
							</h4>
							<p>	
								<span class="timeTag">{{ item.timeConf ? parseTime(item.timeConf,'{y}/{m}/{d}') : parseTime(item.createTime,'{y}/{m}/{d}') }}</span>
							</p>
							<div class="descText">{{ item.titleDescription }}</div>
						</div>
					</el-card>
				<!-- </el-timeline-item> -->
			</template>
		</el-timeline>
		<div class="paging">
			<el-pagination 
				layout="prev, pager, next" 
				hide-on-single-page
				:total="total" 
				:page-size="queryParams.pageSize"
				@current-change="changePage" />
		</div>
	</div>
</template>

<script setup>
	import { getPartDetail } from '@/api/index'
	import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
	import { useRouter } from 'vue-router'
	
	const { proxy } = getCurrentInstance(); 
	let router = useRouter();
	let newsList = ref([])//大事件4
	let total = ref(0)
	let queryParams = reactive({
		moduleId: proxy.partten.moduleNews,
		ifPage: 1,
		pageNum: 1,
		pageSize: 6
	})
	
	onMounted(()=>{
		getList()
	})
	const changePage = (val) => {
		queryParams.pageNum = val;
		getList()
	}
	const getList = () => {
		getPartDetail(queryParams).then((res)=>{
			newsList.value = res.rows;
			total.value = res.total;
		})
	}
	const toDetail = (item) => {
		if(item.hyperLink){
			window.open(item.hyperLink)
		}else{
			router.push('/introduce/news-detail/'+item.id)
		}
	}
</script>
<style lang="less">
  @import '@/assets/css/common';
</style>
<style lang="less" scoped>
.el-card{
	margin-bottom: 20px;
	&:hover{
		h4{
			color: #ff5a00;
		}
	}
	/deep/ .el-card__body{
		display: flex;align-items: flex-start;justify-content: flex-start;
		flex-wrap: nowrap;
		.imgBox{
			width: 160px;height: 90px;overflow: hidden;margin-right: 12px;
			background: #eee;display: flex;align-items: center;
			img{
				width: 100%;height: 100%;object-fit: cover;
			}
		}
		.conBox{
			flex: 1;
			h4{
				font-size: 18px;
			}
		}
	}
	
}
.timeTag{
	color: #909399;font-size: 12px;font-weight: normal;
}
.descText{
	display: -webkit-box;overflow: hidden;text-overflow: ellipsis;
	-webkit-line-clamp: 2;-webkit-box-orient:vertical;
}
</style>
